module.exports = __webpack_public_path__ + "media/logo/logo_farmnote-a2379fa1.png";